var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("test")]),_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){return _vm.getTest()}}},[_vm._v("get")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }